import styled from 'styled-components';

export const History = styled.ul`
  margin: var(--neg-size-6) 0;
  padding: 0;
`;

interface HistoryItemProps {
  addition: boolean;
}

export const HistoryItem = styled.li<HistoryItemProps>`
  padding: var(--size-3) 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.global.primary_border_color};

  h3 {
    font-size: 16px;
  }

  h2 {
    font-size: 16px;
    ${({ addition, theme }) =>
      addition &&
      `
    color: ${theme.global.primary_active_color};
  `}
  }

  &:last-of-type {
    border: none;
  }
`;

export const EmptyState = styled.div`
  h3 {
    font-size: 20px;
    font-family: ${({ theme }) => theme.primary_font.bold.font_family};
    margin: 0 auto;
  }

  button {
    width: 100%;
  }
`;
